import { CustomHandlerWithResult } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

interface Props {
    selectedOrdersList: any;
}
interface Props {
    trackOrdersList: any;
}
export interface SelectedOrdersModel {
    selectedOrdersList: any;
}

type HandlerType = CustomHandlerWithResult<SelectedOrdersModel,Props>;

export const DispatchCompleteLoadOrdersList: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/DispatchCompleteLoadSelectedOrders",
        selectedOrdersList: props.parameter.selectedOrdersList ?? [],
    });
};

export const DispatchCompleteTrackinOrderList: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/DispatchCompleteLoadSelectedOrders",
        trackOrdersList: props.trackingOrdersList ?? [],
    });
};

export const chain = [DispatchCompleteLoadOrdersList, DispatchCompleteTrackinOrderList];

const selectedOrdersList = createHandlerChainRunner(chain, "selectedOrdersList");
export default selectedOrdersList;
